import React from "react";
import Icon from "./Icon";

// Champ de la maquette : fond violet léger, libellé au-dessus de la saisie,
// trait violet en bas (rouge en erreur). `children` accueille la saisie : un
// <input> (voir TextField) ou un champ Stripe.
export default function Field({ label, htmlFor, error, trailing, className = "", children }) {
  return (
    <div className={className}>
      <div
        className={`flex items-center gap-2 px-4 py-2 focus-within:shadow-[inset_0_-1px_0_0_currentColor] ${
          error ? "bg-qv-red-50 border-b-2 border-qv-red text-qv-red" : "bg-[rgba(91,62,255,.06)] border-b border-qv-brand text-qv-brand"
        }`}
      >
        <div className="flex-1 min-w-0">
          <label htmlFor={htmlFor} className={`block text-xs font-semibold ${error ? "text-qv-red" : "text-qv-muted"}`}>
            {label}
          </label>
          {children}
        </div>
        {trailing}
      </div>
      {error && (
        <p className="mt-2 flex gap-2 items-start text-[13px] leading-5 font-medium text-qv-red md:text-sm" role="alert">
          <Icon name="danger-circle-linear" size={18} className="mt-px" />
          {error}
        </p>
      )}
    </div>
  );
}

export const INPUT_CLASSES =
  "block w-full pt-0.5 border-0 bg-transparent outline-none font-montserrat text-base text-qv-ink placeholder:text-[#A1A1AA]";

export function TextField({ id, label, error, trailing, className, inputRef, ...inputProps }) {
  return (
    <Field label={label} htmlFor={id} error={error} trailing={trailing} className={className}>
      <input id={id} ref={inputRef} className={INPUT_CLASSES} aria-invalid={Boolean(error)} {...inputProps} />
    </Field>
  );
}
